import React from 'react';
import WOW from 'wowjs';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import translate from '../translate';

function ContactInfo() {
    const language = useSelector((state) => state.view.selectedLanguage);
    const componentName = 'contactInfo';

    useEffect(() => {
        const wow = new WOW.WOW({
            live: false,
            offset: 100,
            mobile: true,
        });
        wow.init();
    }, []);

    return (
        <div className="contact-info theme-light-bg pt-130">
        <div className="container">
            <div className="row mt-none-30">
                <div className="col-xl-4 col-lg-6 col-md-6 mt-30">
                    <div className="contact-info-box contact-info-box__1 wow fadeInUp" data-wow-delay="0ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/phone.png" alt=""/>
                        </div>
                        <div className="content">
                            <span>{translate(componentName, 'freeConsultation', language)}</span>
                            <p>{translate(componentName, 'freeConsultationDescription', language)}</p>
                            <Link to="/contact" className="btn">{translate(componentName, 'scheduleNow', language)} <span></span></Link>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6 mt-30">
                    <div className="contact-info-box contact-info-box__2 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/envelope.png" alt=""/>
                        </div>
                        <div className="content">
                            <span>{translate(componentName, 'request', language)}</span>
                            <p>{translate(componentName, 'requestDescription', language)}</p>
                            <Link to="/contact" className="btn">{translate(componentName, 'sendRequest', language)} <span></span></Link>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6 mt-30">
                    <div className="contact-info-box contact-info-box__3 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/desk.png" alt=""/>
                        </div>
                        <div className="content">
                            <span>{translate(componentName, 'helpDesk', language)}</span>
                            <p>{translate(componentName, 'helpDeskDescription', language)}</p>
                            <div className="info-call">
                                <span className="icon"><img src="assets/img/icons/whatsapp.png" alt=""/></span>
                                <span className="number">{translate(componentName, 'phoneNumber', language)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default ContactInfo;